import React, { useContext } from 'react';
import Context from '../../../../utils/context';
import { isFeatureEnabled, FEATURES } from '../../../../helpers/feature_checker';
import Legacy from './index.jsx';
import V2 from './v2.jsx';

export default function BylvayQuestionnaireGated(props) {
  const ctx = useContext(Context);
  const account = ctx?.auth?.currentAccount ? ctx.auth.currentAccount() : null;
  return isFeatureEnabled(account, FEATURES.NEW_UI) ? <V2 {...props} /> : <Legacy {...props} />;
}
